module.exports = __webpack_public_path__ + "img/7.60490486.png";